export const UserCheck = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1_6704)">
<circle cx="12" cy="9" r="6" stroke="currentColor" stroke-width="2"/>
<path d="M3 30V25C3 21.6863 5.68629 19 9 19H15C18.3137 19 21 21.6863 21 25V30" stroke="currentColor" stroke-width="2"/>
<path d="M21.7023 14.281L25.0188 17.6008L31.2951 11.2964" stroke="currentColor" stroke-width="2"/>
</g>
<defs>
<clipPath id="clip0_1_6704">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;
